<template>
  <!-- 我的文件 -->
  <el-card shadow="never" class="join_card">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">我的文件</span>
      </div>
    <div class="space">
      <div class="fileList" style="margin-top: 9px">
        <searchForm
          ref="form"
          :searchData="queryParams"
          :searchForm="searchForm"
          :searchHandle="searchHandle"
        ></searchForm>
        <div style="float: right;margin-bottom: 10px">
            <el-button @click="handleDownloads()" size="small">批量下载</el-button>
        </div>
        <el-table
          :height="`calc(100vh - 278px)`"
          border
          ref="singleTable"
          :header-cell-style="{background:'#F5F5F5'}"
          :data="fileList"
          @selection-change="handleSelectionChange"
          row-key="sfFileId"
          header-align="center"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column prop="sfFileName" label="名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <svg-icon v-if="scope.row.sfFileType == 'd'" icon-class="files" />
              <span v-else>
                <svg-icon
                  v-if="scope.row.sfFileExpandName == 'jpeg' || scope.row.sfFileExpandName == 'png' || scope.row.sfFileExpandName == 'jpg'"
                  icon-class="pic"
                />
                <svg-icon v-else icon-class="fileText" />
              </span>
              {{scope.row.sfFileName}}
            </template>
          </el-table-column>
          <el-table-column prop="sfFileSizeStr" align="center" label="大小"></el-table-column>
          <el-table-column prop="sfFileModifyTime" align="center" label="上传时间"></el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.sfFileType == 'f'"
                size="mini"
                type="text"
                @click="handleDownload(scope.row)"
              >下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
</template>

<script>
import searchForm from "@/components/searchItem"
import {
  myFileList,
} from "@/api/request"
import { getClient } from "@/plugins/auth";

export default {
  components: {
    searchForm,
  },
  data () {
    return {
      userInfo: JSON.parse(getClient()),
      fileList: [],
      total: 0,
      selectionList: [],
      ids: [],
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sfFileName: undefined,
        startTime: undefined,
        endTime: undefined,
        timerange: [],
      },
      spaceList: [],
      searchHandle: [{ label: "查询", type: "primary", handle: this.getspaceFileList }],
      searchForm: [
        {
          type: "Input",
          prop: "sfFileName",
          placeholder: "文件名称"
        },
        {
          type: "daterange",
          prop: "timerange",
          width: "150px",
          startPlaceholder: "上传开始时间",
          endPlaceholder: "上传结束时间"
        }
      ]
    }
  },
  mounted () {
    this.getspaceFileList()
  },
  methods: {
    getspaceFileList () {
      let params = {
        sfFileName: this.queryParams.sfFileName,
        sfFileCreaterId: this.userInfo.clientId,
        startTime:
          this.queryParams.timerange != null
            ? this.queryParams.timerange[0]
            : undefined,
        endTime:
          this.queryParams.timerange != null
            ? this.queryParams.timerange[1]
            : undefined
      }
      myFileList(params).then(res => {
        this.fileList = this.handleTree(res.rows, "sfFileId", "sfParentFileId")
        this.list = res.rows
      })
    },
    // 多选框选中数据
    handleSelectionChange (selection) {
      this.selectionList = selection
      console.log(selection,this.selectionList);
      this.ids = selection.map(item => item.sfFileId)
    },
    // 单个下载
    handleDownload (row) {
      let url = process.env.VUE_APP_FILE_API
      var alink = document.createElement("a")
      alink.href = url + row.sfFileUrl
      alink.download = row.sfFileName
      alink.click()
    },
    // 批量下载
    handleDownloads () {
      if (this.selectionList.length == 0) {
        return  this.$message.error("请选择需要下载的文件")
      }  
      let ids = []
      let fileIds = [...new Set(this.getAllId(ids, this.selectionList))]
      if (fileIds.length != 0) {
        this.$download.getDownLoadXls('/fileSpace/fileShared/exportFileList', { fileIds: fileIds.toString() })
      } else {
        this.$message.error("所选列表没有可下载的文件")
      }
    },
    // 递归 获取所有children的id
    getAllId (keys, dataList) {
      if (dataList && dataList.length) {
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].sfFileType != "d") {
            keys.push(dataList[i].sfFileId)
          }
          if (dataList[i].children) {
            keys = this.getAllId(keys, dataList[i].children)
          }
        }
      }
      return keys
    },
  }
};
</script>